import script from "./BottomTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomTab.vue?vue&type=script&setup=true&lang=js"

import "./BottomTab.vue?vue&type=style&index=0&id=f409c3e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f409c3e8"]])

export default __exports__